// @ts-nocheck TODO migrate to functional component

import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import { WithTranslations } from 'components/HOC/WithTranslations/WithTranslations';
import { COOKIE_NAME } from 'constants/cookies';
import { Component } from 'react';
import { connect } from 'react-redux';
import type { RootState } from 'reducers/types';
import { isEUMemberAccess } from 'selectors/geolocation/geolocation';
import { isEmbedded, isFetching } from 'selectors/ui/ui';
import { cookies } from 'utils/cookies/cookies';

import './CookiesBanner.scss';

class CookiesBannerComponent extends Component {
  state = { hasCookie: cookies.read(COOKIE_NAME) };

  handleClick = () => {
    cookies.set(COOKIE_NAME, true);

    this.setState({
      hasCookie: true,
    });
  };

  render() {
    const { cookiePolicyUrl, i18n, isEmbedded, isEUMemberAccess, isFetching } =
      this.props;
    const { hasCookie } = this.state;

    if (isFetching || isEmbedded) {
      return null;
    }

    const shouldShowCookieBanner = !hasCookie && isEUMemberAccess;
    const link = (
      <a
        href={cookiePolicyUrl}
        title={i18n.t('cookiesBanner.linkTitle')}
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        {i18n.t('cookiesBanner.linkTitle')}
      </a>
    );

    return (
      shouldShowCookieBanner && (
        <div
          className="CookiesBanner"
          role="dialog"
          aria-describedby="CookiesBanner-content"
          aria-label="Cookie Law"
        >
          <button
            type="button"
            className="CookiesBanner-close"
            onClick={this.handleClick}
            aria-label="Close"
            data-testid="cookiesBannerButton"
          />
          <div id="CookiesBanner-content">
            {i18n.t('cookiesBanner.description')} {link}
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  isEmbedded: isEmbedded(state),
  isFetching: isFetching(state, 'geolocation'),
  isEUMemberAccess: isEUMemberAccess(state),
});

const connector = connect(mapStateToProps);
const CookiesBanner = WithTranslations(
  WithFlysiteUrls(connector(CookiesBannerComponent)),
);

export { CookiesBanner };
